import type { ComponentPropsWithRef } from 'react';

import { useTranslation } from 'react-i18next';

import { Card, Title } from '~/components';
import { clsx } from '~/styles/utils';

import {
  accountCompletionCardStyle,
  headerStyle,
  headerWrapperStyle,
  progressLabelStyle,
  progressStyle,
} from './AccountCompletionCard.css';

type Props = ComponentPropsWithRef<'div'> & {
  completedSteps: number;
  totalSteps: number;
};

export const AccountCompletionCard = ({ children, completedSteps, totalSteps, ...delegated }: Props) => {
  const { t } = useTranslation(['dashboard']);

  return (
    <Card.Root {...delegated} className={clsx(accountCompletionCardStyle, delegated.className)}>
      <div className={headerWrapperStyle}>
        <div className={headerStyle}>
          <Title as="h2" styleAs="h3">
            {t('dashboard:progression.title')}
          </Title>

          <p aria-hidden className={progressLabelStyle} id="completion-label">
            {t('dashboard:progression.progress', { completedSteps, totalSteps })}
          </p>
        </div>

        <p>{t('dashboard:progression.subtitle', { count: totalSteps - completedSteps })}</p>
      </div>

      <progress aria-labelledby="completion-label" className={progressStyle} id="completion" max={totalSteps} value={completedSteps} />

      <ul>{children}</ul>
    </Card.Root>
  );
};
